import * as React from "react";
import SecNavigationDesktop from "../../../generic/SecNavigation/SecNavigationDesktop";
import { holdSecNavOptions, EHoldScreenState, holdNote } from "../holdConstants";
import { IHoldRouteParams } from "../../../types/components/holdings/holdTypes";
import { useRouteMatch, Link } from "react-router-dom";
import HoldTotalBlock, { IHoldTotalBlockProps } from "../generic/holdTotalBlock";
import NoDataContainer from "../../../generic/noDataContainer";
import Loader from "../../../generic/loader";
import TocNoteDsk from "../../../toc/generic/tocNote/tocNoteDsk";
import "../../../../assets/scss/components/generic/layout/layoutDesk.scss";
import "../../../../assets/scss/components/toc/holdings/holdingsDsk.scss";

export interface IHoldLayoutDskProps {
	totalBlockData: IHoldTotalBlockProps;
	screenState: EHoldScreenState;
}

const HoldLayoutDsk: React.FC<IHoldLayoutDskProps> = props => {
	const routeParams = useRouteMatch<IHoldRouteParams>();
	const [isFixed, setIsFixed] = React.useState<boolean>(false);

	function onContainerScroll(e: React.UIEvent<HTMLElement>) {
		// console.dir((e.target as HTMLElement).scrollTop);
		// if scrolltop is greater than 78 then fix the header
		(e.target as HTMLElement).scrollTop > 90 ? !isFixed && setIsFixed(true) : isFixed && setIsFixed(false);
	}

	return (
		<section className={"outer_container container_desk hold_container_desk" + (isFixed ? " hold_scroll_active" : "")}>
			<section className="lyCont">
				<section className="list_view">
					<div className="ly_list_view">
						<div className="lv_menu">
							<SecNavigationDesktop defaultValue={routeParams.url.split("/")[2] || "equity"} list={holdSecNavOptions} />

							<div className="detailed_holdings_cont">
								<Link to="#" className="detailed_holdings">
									<span>
										Detailed Holdings <i className="edel-icon-arrow-right " />
									</span>
								</Link>
							</div>

							<TocNoteDsk>{holdNote}</TocNoteDsk>
						</div>
					</div>
					{props.screenState === EHoldScreenState.DATA && (
						<div className="ly_right_cont" onScroll={onContainerScroll}>
							<div className="ob_header">
								<HoldTotalBlock {...props.totalBlockData} />
							</div>
							<div className="ob_history">{props.children}</div>
						</div>
					)}
					{props.screenState === EHoldScreenState.NO_DATA && (
						<div className="ly_right_cont">
							<NoDataContainer txtHeading="Lorem Ipsum Dolor sit amet Consecutor" txtSubHeading="" />
						</div>
					)}
					{props.screenState === EHoldScreenState.LOADING && (
						<div className="ly_right_cont hold_loader_cont">
							<Loader size={20} color="blue" />
						</div>
					)}
				</section>
			</section>
		</section>
	);
};

export default HoldLayoutDsk;
